import React, { ButtonHTMLAttributes, Fragment } from "react";

type ButtonSecondaryModalProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  text?: string;
};

export const ButtonSecondaryModal: React.FC<ButtonSecondaryModalProps> = ({
  text,
  ...props
}) => (
  <Fragment>
    <button
      {...props}
      type="button"
      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
    >
      {text}
    </button>
  </Fragment>
);
